import { useFetcher } from "@remix-run/react";
import { settingsAtom, useIsMobile } from "core/shared";
import { URLS as FRAMEWORK_URLS } from "framework/config/urls";
import { useEffect } from "react";
import { BaseLink } from "~/design-system/components";
import { MenuResponse } from "~/shared/types";
import { URLS } from "~/shared/urls";
import { headerMenuAtom, searchAtom } from "../../atoms";
import {
  CartHeaderLink,
  DropdownMenu,
  HeaderMenu,
  MenuButton,
  UserButtons,
} from "../Header/components";
import { HeaderSearch } from "../Header/components/search";

export function HeaderV2() {
  const logo = settingsAtom.use("general.logo");

  const { isMobile } = useIsMobile(1024);

  const fetcher = useFetcher<MenuResponse>();

  useEffect(() => {
    fetcher.load(FRAMEWORK_URLS.menu);
  }, []);

  const documents = fetcher.data?.documents;

  return (
    <div className="border-b border-black py-4">
      <div className="container flex items-center justify-between gap-2 lg:gap-5">
        <BaseLink
          to={URLS.home}
          onClick={() => {
            headerMenuAtom.close();
            searchAtom.close();
          }}
          // className="min-w-[175px]"
        >
          <img src={logo?.url} alt="Nanni's Cakes" className="h-[65px]" />
        </BaseLink>
        {!isMobile && <DropdownMenu documents={documents} />}
        <div className="ml-auto flex items-center gap-4 lg:gap-6">
          <UserButtons />
          <CartHeaderLink />

          {isMobile && <MenuButton />}
        </div>
      </div>
      <HeaderSearch />
      {isMobile && <HeaderMenu documents={documents} />}
    </div>
  );
}
